<div class="icon-wrapper" [ngStyle]="{'width': iconSize(), 'height': iconSize()}">
    <cwo-icon class="icon" [name]="iconName()"></cwo-icon>
</div>
<div class="label-value-wrapper">
    <span class="label">{{label()}}</span>
    @if(valueRef){
    <div class="container-wrapper">
        <ng-container [ngTemplateOutlet]="valueRef"></ng-container>
    </div>
    } @else {
    <span class="value">{{value()}}</span>
    }
</div>